import React from 'react';
import { Link } from 'react-router-dom';
import { DotGridBackground } from './DotGridBackground';

const STEPS = { account: 1, business: 2, plans: 3, checkout: 4 };
export const ReviewShell = ({ step, children, preview = true, totalSteps = 4 }) => <main className="signup-review" data-testid={preview ? 'signup-review-page' : 'signup-page'}>
  <DotGridBackground />
  {preview && <header className="sr-review-bar" data-testid="signup-review-notice">
    <span data-testid="signup-review-mock-status">MOCKUP · No accounts or payments</span>
    <a href="/review/paid-signup/index.html" data-testid="signup-review-gallery-link">View all screens</a>
  </header>}
  <div className={`sr-stage sr-stage-${step}`}>
    <section className="sr-content" aria-labelledby="signup-review-title" data-testid="signup-review-panel">
      <Link to="/" className="sr-logo" aria-label="Voxinity AI home" data-testid="signup-review-home-link">
        <img src="/voxinity-logo.png" alt="Voxinity AI" width="124" data-testid="signup-review-logo" />
      </Link>
      {step !== 'account' && step !== 'success' && <p className="sr-progress" aria-label={`Step ${STEPS[step]} of ${totalSteps}`} data-testid="signup-review-progress">Step {STEPS[step]} of {totalSteps}</p>}
      {children}
      <footer className="sr-legal" data-testid="signup-review-legal">
        <p data-testid="signup-review-legal-copy">{step === 'account' && 'By continuing, you agree to our '}<a href="/terms" target="_blank" rel="noopener noreferrer" data-testid="signup-review-terms-link">Terms of Service</a>{step === 'account' ? ' and ' : ' · '}<a href="/privacy" target="_blank" rel="noopener noreferrer" data-testid="signup-review-privacy-link">Privacy Policy</a>{step === 'account' && '.'}</p>
      </footer>
    </section>
  </div>
</main>;